import { state, style, trigger } from '@angular/animations';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatPaginator } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { NoDataComponent } from '@app/shared/components/no-data/no-data.component';
import { ThrottleEventDirective } from '@app/shared/directives/throttle-event.directive';
import { FormatAdressPipe } from '@app/shared/pipes/formatadress.pipe';
import { FormatDatePipe } from '@app/shared/pipes/formatdate.pipe';
import { BasicPolizzeListComponent } from '../basic-polizze-list/basic-polizze-list.component';

@Component({
  selector:    'app-verdorbene',
  templateUrl: './verdorbene.component.html',
  styleUrls:   ['./verdorbene.component.scss'],
  animations:  [
    trigger('detailExpand', [
      state('collapsed', style({
        display: 'none'
      })),
      state('expanded', style({
        height:     '*',
        visibility: 'visible'
      }))
    ])
  ],
  standalone:  true,
  imports: [
    NgIf,
    MatTable,
    MatSort,
    NgFor,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIconButton,
    MatIcon,
    ThrottleEventDirective,
    MatTooltip,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgClass,
    MatPaginator,
    MatProgressSpinner,
    NoDataComponent,
    FormatDatePipe,
    FormatAdressPipe,
    AsyncPipe
  ]
})
export class VerdorbeneComponent extends BasicPolizzeListComponent {

  protected get displayedColumns(): string[] {
    const columns = this.tableColumns.map(c => c.columnDef);
    if (this.bearbeitenErlaubt) {
      columns.push('aktionen');
    }
    return columns;
  }

  getAnzRowsPerEntry(): number {
    return 2;
  }
}
